import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'card_card';
export const useCardCardTranslation = (): UseTranslationResponse<'shared', typeof keyPrefix> => {
  return useTranslation('shared', { keyPrefix });
};

export const ruRu = ({
  [keyPrefix]: {
    match_tag: 'Совпадение',
    similarity_tag: 'Карточка',
    full_name: 'ФИО',
    lists: 'Списки',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    match_tag: 'Match',
    similarity_tag: 'Card',
    full_name: 'Full name',
    lists: 'Lists',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    match_tag: 'Correspondência',
    similarity_tag: 'Cartão',
    full_name: 'Nome completo',
    lists: 'Listas',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    match_tag: 'Coincidencia',
    similarity_tag: 'Tarjeta',
    full_name: 'Nombre completo',
    lists: 'Listas',
  },
}) as Record<string, unknown>;
